export const LogoMark = ({ className = "w-9 h-9", draw = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="lm-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F3E5AB" />
        <stop offset=".5" stopColor="#D4AF37" />
        <stop offset="1" stopColor="#8A6A12" />
      </linearGradient>
    </defs>
    <path className={draw ? "ld-path" : ""} d="M32 5 L56 18.5 V45.5 L32 59 L8 45.5 V18.5 Z" fill="none" stroke="url(#lm-g)" strokeWidth="2.4" />
    <path d="M20 24 L24 16.5 L28.5 21.5 L32 14 L35.5 21.5 L40 16.5 L44 24 Z" fill="url(#lm-g)" />
    <path className={draw ? "ld-path" : ""} d="M25 28.5 H34.5 a5.5 5.5 0 0 1 0 11 H25 M25 39.5 H36 a5.75 5.75 0 0 1 0 11.5 H25 V28.5" fill="none" stroke="url(#lm-g)" strokeWidth="3.4" strokeLinejoin="round" />
    <circle cx="47" cy="43" r="2.2" fill="#00F0FF" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-display font-extrabold tracking-[0.18em] text-[15px] text-white">BOSS EMPIRE</span>
      <span className="block font-mono text-[10px] tracking-[0.32em] text-[#d9bf6a] mt-1">PRIVATE LIMITED</span>
    </span>
  </span>
);
